webpackJsonp([258235838405324],{

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostsTemplate = function (_Component) {
	  _inherits(PostsTemplate, _Component);
	
	  function PostsTemplate() {
	    _classCallCheck(this, PostsTemplate);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PostsTemplate.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Posts'
	      ),
	      data.allWordpressPost.edges.map(function (_ref) {
	        var node = _ref.node;
	        return _react2.default.createElement(
	          'div',
	          { key: node.slug, className: 'post', style: { marginBottom: 50 } },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: 'post/' + node.slug },
	            _react2.default.createElement(
	              'h3',
	              null,
	              node.title
	            )
	          ),
	          _react2.default.createElement('div', {
	            className: 'post-content',
	            dangerouslySetInnerHTML: { __html: node.excerpt }
	          }),
	          _react2.default.createElement(
	            'div',
	            null,
	            node.date
	          )
	        );
	      })
	    );
	  };
	
	  return PostsTemplate;
	}(_react.Component);
	
	PostsTemplate.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  edges: _propTypes2.default.array
	};
	
	exports.default = PostsTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-posts-index-js-3df259141aa76b74bc90.js